import { Link } from 'react-router-dom';
import CtaBand from '../components/CtaBand';
import Icon from '../components/Icon';
import Layout, { PageHero } from '../components/Layout';
import { WHY_US } from '../constants/content';
import { COMPANY_NAME, SITE_NAME } from '../constants/site';

const VALUES = [
  { title: 'Patience first', text: 'Family history attracts people of every age and confidence level. Nobody is ever made to feel rushed or silly.' },
  { title: 'Honest about limits', text: 'If only Ancestry itself can solve your problem, we say so immediately rather than wasting your time.' },
  { title: 'Teach, don’t just fix', text: 'We explain what went wrong so you can handle it yourself next time.' },
];

export default function AboutPage() {
  return (
    <Layout>
      <PageHero
        eyebrow="About us"
        title="People who love family history — and fixing things"
        lead={`${SITE_NAME} is an independent helps service run by ${COMPANY_NAME}.`}
        crumbs={[{ label: 'About Us' }]}
      />

      <section className="section">
        <div className="container about-grid">
          <div className="prose">
            <h2>Why we started</h2>
            <p>
              Researching your family is meant to be rewarding: the thrill of finding a great-grandparent in a census,
              or a DNA match that solves a decades-old mystery. Too often, though, that joy gets interrupted by a
              password that won’t reset, a tree that won’t load, or an app that stopped working after an update.
            </p>
            <p>
              We created {SITE_NAME} to give family historians a patient, plain-English place to turn when the
              technology gets in the way. Our team combines everyday tech helps skills with real genealogy
              experience, so we understand both the error message and the research you are trying to protect.
            </p>
            <h2>Independent by design</h2>
            <p>
              We are not part of Ancestry.com and are not endorsed by it. Ancestry provides its own official help
              centre, and you are always welcome to use it. We offer an independent alternative focused on
              one-to-one guidance. Read our <Link to="/disclaimer">disclaimer</Link> for details.
            </p>
          </div>
          <aside className="about-values">
            {VALUES.map((v) => (
              <div key={v.title} className="value-card">
                <Icon name="leaf" size={24} />
                <div>
                  <h3>{v.title}</h3>
                  <p>{v.text}</p>
                </div>
              </div>
            ))}
          </aside>
        </div>
      </section>

      <section className="section section--soft">
        <div className="container">
          <div className="section-head">
            <h2>What you can expect from us</h2>
          </div>
          <div className="card-grid card-grid--4">
            {WHY_US.map((w) => (
              <article key={w.title} className="why-card">
                <Icon name={w.icon} size={28} />
                <h3>{w.title}</h3>
                <p>{w.text}</p>
              </article>
            ))}
          </div>
        </div>
      </section>

      <CtaBand />
    </Layout>
  );
}
